import { loginByUsername, logout, getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken, getUserId, setUserId, removeUserId, getFoundId, setFoundId, removeFoundId,
  getPlotId, setPlotId, removePlotId, getPlotName, setPlotName, removePlotName, removeMode, removeMode1, removeMode2,
  getType, setType, removeType, getName, setName, removeName
} from '@/utils/auth'
import router, { resetRouter } from '@/router'
import { getTypeOption } from '@/api/agricultural'

const user = {
  state: {
    userId: getUserId(),
    token: getToken(),
    type: getType(),
    name: getName(),
    realName: '',
    avatar: '',
    foundId: getFoundId(),
    plotId: getPlotId(),
    plotName: getPlotName(),
    role: '',
    power: '',
    loading: false,
    setloading: false,
    pointX: 0,
    pointY: 0
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_UID: (state, userId) => {
      state.userId = userId
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_REALNAME: (state, realName) => {
      state.realName = realName
    },
    SET_FOUNDID: (state, foundId) => {
      state.foundId = foundId
    },
    SET_PLOTID: (state, plotId) => {
      state.plotId = plotId
    },
    SET_PLOTNAME: (state, plotName) => {
      state.plotName = plotName
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_POWER: (state, power) => {
      state.power = power
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_SETLOADING: (state, setloading) => {
      state.setloading = setloading
    },
    SET_POINTX: (state, pointX) => {
      state.pointX = pointX
    },
    SET_POINTY: (state, pointY) => {
      state.pointY = pointY
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const user_name = userInfo.username.trim()
      const password = userInfo.password.trim()
      const platform ='system'
      const type = userInfo.tab
      return new Promise((resolve, reject) => {
        loginByUsername({user_name, password, platform, type}).then(response => {
          const userId = response.data.data.user_id
          const user_name = response.data.data.user_name
          localStorage.setItem("token", response.data.data.token);
          const token=response.data.data.token
          const type=response.data.data.type

          commit('SET_UID', userId)
          commit('SET_NAME', response.data.data.nick_name)
          commit('SET_AVATAR', response.data.data.photo)
          setUserId(userId)
          setToken(token)
          setType(type)
          setName(response.data.data.nick_name)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.userId).then(response => {
          const data = response.data.data
         
          commit('SET_ROLE', data.role)
          commit('SET_NAME', data.nick_name)
          commit('SET_REALNAME', data.real_name)
          commit('SET_AVATAR', data.photo)
          commit('SET_POWER', data.power)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        logout({user_id:Number(state.userId), platform:'system', type:Number(getType())}).then(() => {
          commit('SET_UID', '')
          commit('SET_ROLE', '')
          commit('SET_POWER', '')
          commit('SET_FOUNDID', '')
          commit('SET_PLOTID', '')
          commit('SET_PLOTNAME', '')
          commit('SET_AVATAR', '')
          removeUserId()
          removeFoundId()
          removePlotId()
          removePlotName()
          removeMode()
          removeMode1()
          removeMode2()
          removeType()
          removeName()
          localStorage.clear()
          resetRouter()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_UID', '')
        commit('SET_ROLE', '')
        commit('SET_POWER', '')
        commit('SET_FOUNDID', '')
        commit('SET_PLOTID', '')
        commit('SET_PLOTNAME', '')
        removeUserId()
        removeFoundId()
        removePlotId()
        removePlotName()
        removeMode()
        removeMode1()
        removeMode2()
        removeType()
        removeName()
        localStorage.clear()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise(async resolve => {
        commit('SET_TOKEN', role)
        setToken(role)

        const { roles } = await dispatch('GetUserInfo')

        resetRouter()

        const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

        // dynamically add accessible routes
        router.addRoutes(accessRoutes)

        // reset visited views and cached views
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      })
    }
  }
}

export default user
